interface AdminPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  summary?: string | null;
  showFirstLast?: boolean;
  className?: string;
}

export default function AdminPagination({
  currentPage,
  totalPages,
  onPageChange,
  summary,
  showFirstLast = false,
  className = '',
}: AdminPaginationProps) {
  const safeTotalPages = Math.max(1, totalPages);
  const safeCurrentPage = Math.min(Math.max(1, currentPage), safeTotalPages);

  const goToPage = (page: number) => {
    onPageChange(Math.min(Math.max(1, page), safeTotalPages));
  };

  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 ${className}`.trim()}>
      <p className="text-xs font-medium text-on-surface-variant">{summary || '\u00A0'}</p>

      <div className="flex flex-wrap items-center justify-end gap-2 sm:ml-auto">
        {showFirstLast ? (
          <button
            type="button"
            aria-label="Première page"
            disabled={safeCurrentPage <= 1}
            onClick={() => goToPage(1)}
            className="rounded-md border border-outline-variant/40 px-2.5 py-1 text-[11px] font-bold text-slate-700 transition hover:bg-surface-container-high disabled:cursor-not-allowed disabled:opacity-50"
          >
            Première
          </button>
        ) : null}

        <button
          type="button"
          aria-label="Page précédente"
          disabled={safeCurrentPage <= 1}
          onClick={() => goToPage(safeCurrentPage - 1)}
          className="rounded-md border border-outline-variant/40 px-2.5 py-1 text-[11px] font-bold text-slate-700 transition hover:bg-surface-container-high disabled:cursor-not-allowed disabled:opacity-50"
        >
          Précédent
        </button>

        <span className="min-w-[6.2rem] px-1 text-center text-[11px] font-bold text-slate-700">
          {`Page ${safeCurrentPage} / ${safeTotalPages}`}
        </span>

        <button
          type="button"
          aria-label="Page suivante"
          disabled={safeCurrentPage >= safeTotalPages}
          onClick={() => goToPage(safeCurrentPage + 1)}
          className="rounded-md border border-outline-variant/40 px-2.5 py-1 text-[11px] font-bold text-slate-700 transition hover:bg-surface-container-high disabled:cursor-not-allowed disabled:opacity-50"
        >
          Suivant
        </button>

        {showFirstLast ? (
          <button
            type="button"
            aria-label="Dernière page"
            disabled={safeCurrentPage >= safeTotalPages}
            onClick={() => goToPage(safeTotalPages)}
            className="rounded-md border border-outline-variant/40 px-2.5 py-1 text-[11px] font-bold text-slate-700 transition hover:bg-surface-container-high disabled:cursor-not-allowed disabled:opacity-50"
          >
            Dernière
          </button>
        ) : null}
      </div>
    </div>
  );
}
